import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Radio,
    RadioGroup,
    Checkbox,
    Typography,
} from "@mui/material";
import { Button } from "@aidergroup/ui-v2";
import { i18n } from "@/utils/i18n";

interface Props {
    open: boolean;
    onClose(): void;
    reviewOutcome: string;
    onReviewOutcomeChange(value: string): void;
    selectedPages: string[];
    onTogglePage(page: string): void;
    onDownload(): void;
    downloading: boolean;
}

const DownloadDialog: React.FC<Props> = ({
    open,
    onClose,
    reviewOutcome,
    onReviewOutcomeChange,
    selectedPages,
    onTogglePage,
    onDownload,
    downloading,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{i18n.t("reportPreview.dialogTitle")}</DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    {i18n.t("reportPreview.dialogHelp")}
                </Typography>
                <FormGroup sx={{ mb: 2 }}>
                    <FormLabel sx={{ mb: 1 }}>{i18n.t("reportPreview.outcomeTitle")}</FormLabel>
                    <RadioGroup
                        row
                        value={reviewOutcome}
                        onChange={event => onReviewOutcomeChange(event.target.value)}
                    >
                        <FormControlLabel
                            value="WITHOUT_REMARKS"
                            control={<Radio />}
                            label={i18n.t("reportPreview.outcomes.WITHOUT_REMARKS")}
                        />
                        <FormControlLabel
                            value="WITH_CORRECTION"
                            control={<Radio />}
                            label={i18n.t("reportPreview.outcomes.WITH_CORRECTION")}
                        />
                        <FormControlLabel
                            value="WITH_REMARKS"
                            control={<Radio />}
                            label={i18n.t("reportPreview.outcomes.WITH_REMARKS")}
                        />
                    </RadioGroup>
                </FormGroup>
                <FormGroup>
                    {[
                        "FRONT_PAGE",
                        "ECONOMIC_SUMMARY",
                        "ASSETS_DEBTS",
                        "INCOMES_EXPENSES",
                        "VERIFICATIONS",
                        "LEDGER",
                    ].map(page => (
                        <FormControlLabel
                            key={page}
                            control={
                                <Checkbox
                                    checked={selectedPages.includes(page)}
                                    onChange={() => onTogglePage(page)}
                                />
                            }
                            label={i18n.t(`reportPreview.pages.${page}`)}
                        />
                    ))}
                </FormGroup>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button variant="outlined" color="error" onClick={onClose}>
                    {i18n.t("button.cancel")}
                </Button>
                <Button
                    variant="contained"
                    onClick={onDownload}
                    disabled={downloading || selectedPages.length === 0}
                >
                    {i18n.t("button.downloadReportPreview")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DownloadDialog;
